import { render } from "./AddReclamation.vue?vue&type=template&id=67ccf29c&ts=true"
import script from "./AddReclamation.vue?vue&type=script&lang=ts"
export * from "./AddReclamation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__